// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("@tiptap/react");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let Extensions = require("@tiptap/extensions");
let StarterKit = require("@tiptap/starter-kit").default;
let ExtensionLink = require("@tiptap/extension-link").default;

let Heading = {};

let Nodes = {
  Heading: Heading
};

let Link = {};

let Marks = {
  Link: Link
};

let Node = {};

let State = {};

let ProseMirror = {
  Node: Node,
  State: State
};

function canChain(editor) {
  return editor.can().chain();
}

function getLinkAttributes(editor) {
  return Primitive_option.fromNullable(editor.getAttributes("link"));
}

let Attributes = {};

let EditorProps = {
  Attributes: Attributes
};

function noop(param) {
  
}

function make(content, onUpdate, onBlur, onFocus, editorProps, placeholderTextOpt, headingLevelsOpt, param) {
  let placeholderText = placeholderTextOpt !== undefined ? placeholderTextOpt : "";
  let headingLevels = headingLevelsOpt !== undefined ? headingLevelsOpt : [
      1,
      2,
      3
    ];
  return {
    content: content,
    extensions: [
      StarterKit.configure({
        heading: {
          levels: headingLevels
        }
      }),
      Extensions.Underline,
      ExtensionLink.configure({
        openOnClick: false,
        validate: value => {
          let urlWithProtocolRegex = /^https?:\/\//g;
          return urlWithProtocolRegex.test(value);
        }
      }),
      Extensions.Placeholder.configure({
        placeholder: placeholderText,
        emptyEditorClass: "cursor-text before:content-[attr(data-placeholder)] before:absolute before:top-2 before:left-2 before:text-zinc-400"
      }),
      Extensions.Selection.configure({
        className: "fake-selection"
      })
    ],
    onUpdate: Stdlib_Option.getOr(onUpdate, noop),
    onBlur: Stdlib_Option.getOr(onBlur, noop),
    onFocus: Stdlib_Option.getOr(onFocus, noop),
    editorProps: editorProps,
    immediatelyRender: false,
    shouldRerenderOnTransaction: true
  };
}

function useEditor(config) {
  return Primitive_option.fromNullable(React.useEditor(config));
}

function Commands_toggleBold(prim) {
  return prim.toggleBold();
}

function Commands_toggleItalic(prim) {
  return prim.toggleItalic();
}

function Commands_toggleUnderline(prim) {
  return prim.toggleUnderline();
}

function Commands_toggleHeading(prim0, prim1) {
  return prim0.toggleHeading(prim1);
}

function Commands_toggleBulletList(prim) {
  return prim.toggleBulletList();
}

function Commands_toggleOrderedList(prim) {
  return prim.toggleOrderedList();
}

function Commands_focus(prim) {
  return prim.focus();
}

function Commands_extendMarkRange(prim0, prim1) {
  return prim0.extendMarkRange(prim1);
}

function Commands_setLink(prim0, prim1) {
  return prim0.setLink(prim1);
}

function Commands_unsetLink(prim) {
  return prim.unsetLink();
}

let Commands_Chainable = {
  run: prim => prim.run(),
  toggleBold: prim => prim.toggleBold(),
  toggleItalic: prim => prim.toggleItalic(),
  toggleUnderline: prim => prim.toggleUnderline(),
  toggleHeading: (prim0, prim1) => prim0.toggleHeading(prim1),
  toggleBulletList: prim => prim.toggleBulletList(),
  toggleOrderedList: prim => prim.toggleOrderedList(),
  focus: prim => prim.focus(),
  extendMarkRange: (prim0, prim1) => prim0.extendMarkRange(prim1),
  setLink: (prim0, prim1) => prim0.setLink(prim1),
  unsetLink: prim => prim.unsetLink()
};

let Commands = {
  toggleBold: Commands_toggleBold,
  toggleItalic: Commands_toggleItalic,
  toggleUnderline: Commands_toggleUnderline,
  toggleHeading: Commands_toggleHeading,
  toggleBulletList: Commands_toggleBulletList,
  toggleOrderedList: Commands_toggleOrderedList,
  focus: Commands_focus,
  extendMarkRange: Commands_extendMarkRange,
  setLink: Commands_setLink,
  unsetLink: Commands_unsetLink,
  Chainable: Commands_Chainable
};

function Editor_commands(prim) {
  return prim.commands;
}

function Editor_chain(prim) {
  return prim.chain();
}

function Editor_canSingle(prim) {
  return prim.can();
}

function Editor_isActive(prim0, prim1) {
  return prim0.isActive(prim1);
}

function Editor_isHeadingActive(prim0, prim1) {
  return prim0.isActive("heading", prim1);
}

function Editor_getHTML(prim) {
  return prim.getHTML();
}

function Editor_getText(prim) {
  return prim.getText();
}

function Editor_isEmpty(prim) {
  return prim.isEmpty;
}

function Editor_state(prim) {
  return prim.state;
}

function Editor_internal_startDomObserver(prim) {
  prim.view.domObserver.start();
}

function Editor_internal_stopDomObserver(prim) {
  prim.view.domObserver.stop();
}

let Editor_Config = {
  EditorProps: EditorProps,
  make: make
};

let Editor = {
  commands: Editor_commands,
  chain: Editor_chain,
  canSingle: Editor_canSingle,
  canChain: canChain,
  isActive: Editor_isActive,
  isHeadingActive: Editor_isHeadingActive,
  getLinkAttributes: getLinkAttributes,
  getHTML: Editor_getHTML,
  getText: Editor_getText,
  isEmpty: Editor_isEmpty,
  state: Editor_state,
  internal_startDomObserver: Editor_internal_startDomObserver,
  internal_stopDomObserver: Editor_internal_stopDomObserver,
  Config: Editor_Config
};

let ReactTiptap_EditorContent = {
  make: React.EditorContent
};

let ReactTiptap = {
  useEditor: useEditor,
  EditorContent: ReactTiptap_EditorContent
};

exports.Nodes = Nodes;
exports.Marks = Marks;
exports.Commands = Commands;
exports.ProseMirror = ProseMirror;
exports.Editor = Editor;
exports.ReactTiptap = ReactTiptap;
/* ReactTiptap Not a pure module */
